import { Component, lazy } from 'react';
import SubjectCode from '../pages/SubjectCode';
import Reform from '../pages/Reform';
import Information from '../pages/Information';
import ChaptersSubjectCodes from '../pages/ChaptersSubjectCodes';
import TitlesExecutiveAndApproval from '../pages/TitlesExecutiveAndApproval';
import TitlesSubjectCodes from '../pages/TitlesSubjectCodes';
import CreateBook from '../pages/CreateBook';

import UsersManagment from '../pages/UsersManagment';
import LawText from '../pages/LawText';
import Organs from '../pages/Organs';
import Keyword from '../pages/Keyword';
import Topology from '../pages/Topology';
import Dashbord from '../pages/Dashboard/Dashbord';
import NewInformation from '../pages/NewInformation';
import NewInfo from '../pages/NewInfo';
import NewReform from '../pages/NewReform';
import NewOrgans from '../pages/NewOrgans';
import Specificationslaw from '../pages/Specificationslaw';
import NewSubjectCode from '../pages/NewSubjectCode';
import NewTopology from '../pages/NewTopology';
import ChangePasswordBySuperAdmin from '../pages/ChangePasswordBySuperAdmin';
import NewsManagement from '../pages/NewsManagement';
import RolePermissionList from '../pages/RolePermissionList';
import ChangeUserName from '../pages/ChangeUserName';
// import Home from '../pages/Home';
const NaskheZemni =lazy(() => import('../pages/NaskheZemni')); 
const Home =lazy(() => import('../pages/Home')); 
const Calendar = lazy(() => import('../pages/Specificationslaw'));
const Roles = lazy(() => import('../pages/Roles'));
const Permissions = lazy(() => import('../pages/Permissions'));
const Chart = lazy(() => import('../pages/Chart'));
const FormElements = lazy(() => import('../pages/Form/FormElements'));
const FormLayout = lazy(() => import('../pages/Form/FormLayout'));
const Profile = lazy(() => import('../pages/Profile'));
const Settings = lazy(() => import('../pages/Settings'));
const Tables = lazy(() => import('../pages/Tables'));
const Alerts = lazy(() => import('../pages/UiElements/Alerts'));
const Buttons = lazy(() => import('../pages/UiElements/Buttons'));

const coreRoutes = [
  {
    path: '/home',
    title: 'home',
    component: Home,
  },{
    path: '/particulars',
    title: 'particulars',
    component: Calendar,
  },
  {
    path: '/profile',
    title: 'Profile',
    component: Profile,
  },
  {
    path: '/forms/form-elements',
    title: 'Forms Elements',
    component: FormElements,
  },
  {
    path: '/forms/form-layout',
    title: 'Form Layouts',
    component: FormLayout,
  },
  {
    path: '/tables',
    title: 'Tables',
    component: Tables,
  },
  {
    path: '/settings',
    title: 'Settings',
    component: Settings,
  },
  {
    path: '/chart',
    title: 'Chart',
    component: Chart,
  },
  {
    path: '/ui/alerts',
    title: 'Alerts',
    component: Alerts,
  },
  {
    path: '/ui/buttons',
    title: 'Buttons',
    component: Buttons,
  },
  {
    path: '/subjectcode',
    title: 'subjectcode',
    // component: SubjectCode,
    component: NewSubjectCode,
  },{
    path: '/naskh',
    title: 'naskh',
    // component: SubjectCode,
    component: NaskheZemni,
  },
  {
    path: '/reform',
    title: 'reform',
    component: NewReform,
    // component: Reform,
  },
  // {
  //   path: '/reform/:id',
  //   title: 'reform',
  //   component: Reform,
  // },
  {
    path: '/information',
    title: 'information',

    component: NewInfo,
    // component: Information,
  },{
    path: '/information/:id',
    title: 'information',

    component: NewInfo,
    // component: Information,
  },
  {
    path: '/createbook',
    title: 'createbook',
    component: CreateBook,
  },
  {
    path: '/chaptersSubjectCodes',
    title: 'chaptersSubjectCodes',
    component: ChaptersSubjectCodes,
  },
  {
    path: '/titlesExecutiveAndApproval',
    title: 'titlesExecutiveAndApproval',
    component: TitlesExecutiveAndApproval,
  },
  {
    path: '/titlesSubjectCodes',
    title: 'titlesSubjectCodes',
    component: TitlesSubjectCodes,
  },
  {
    path: '/usersmanagement',
    title: 'usersmanagement',
    component: UsersManagment,
  },
  {
    path: '/lawtext',
    title: 'lawtext',
    component: LawText,
  },
  {
    path: '/organs',
    title: 'organs',
    component: NewOrgans,
    // component: Organs,
  },
  {
    path: '/keyword',
    title: 'keyword',
    component: Keyword,
  },
  {
    path: '/topology',
    title: 'topology',
    component: NewTopology,
    // component: Topology,
  },
  {
    path: '/Specificationslaw',
    title: 'Specificationslaw',
    component: Specificationslaw,
  },
  {
    path: '/roles',
    title: 'Roles',
    component: Roles,
  }
  ,{
    path: '/permission',
    title: 'permission',
    component: Permissions,
  }
  
  ,{
    path: '/changepasswordbysuperadmin',
    title: 'changepassword',
    component: ChangePasswordBySuperAdmin,
  }
  ,{
    path: '/News',
    title: 'News',
    component: NewsManagement,
  }
  ,{
    path: '/RolePermission/:id/:description/:name',
    title: 'RolePermission',
    component: RolePermissionList
  },{
    path: '/changeUserName',
    title: 'changeUserName',
    component: ChangeUserName
  }
];

const routes = [...coreRoutes];
export default routes;
